import Breadcrumb from './breadcrumb';
import BreadcrumbItem from './breadcrumb-item';
var DefaultBreadcrumb = Breadcrumb;
DefaultBreadcrumb.Item = BreadcrumbItem;
export default DefaultBreadcrumb;
//# sourceMappingURL=index.js.map